import * as React from 'react';

export interface HtmlChiaSeedProps {
  readonly x: number;
  readonly y: number;
  readonly color: string;
  readonly colorIndicatorsEnabled: boolean;
  readonly haloRatio: number;
}

export const HtmlChiaSeed = (props: HtmlChiaSeedProps): React.ReactElement => {
  const size = 14;
  return (
    <>
      {props.colorIndicatorsEnabled && (
        <div
          style={{
            position: 'relative',
            transform: `translateX(${props.x}px) translateY(${props.y}px)`,
            ...makeDotStyle(size * props.haloRatio),
            backgroundColor: props.color,
            opacity: 0.3,
          }}
        />
      )}
      <div
        style={{
          position: 'relative',
          transform: `translateX(${props.x}px) translateY(${props.y}px)`,
          ...makeDotStyle(size),
          backgroundColor: props.color,
        }}
      />
    </>
  );
};

const makeDotStyle = (size: number): React.CSSProperties => ({
  position: 'absolute',
  left: -size / 2,
  top: -size / 2,
  height: size,
  width: size,
  borderRadius: size,
  border: '1px',
  borderColor: 'white',
  borderStyle: 'solid',
  pointerEvents: 'none',
  boxSizing: 'border-box',
});
